export enum StorageKey {
  // OfflineMode Only
  CURRENT_SENSOR = 'v2-keepTrack-currentSensor',
  WATCHLIST_LIST = 'v2-keepTrack-watchlistList',
  SATELLITE_LISTS = 'v2-keepTrack-satelliteLists',

  // Others
  SETTINGS_DOT_COLORS = 'v2-keepTrack-settings-dotColors',
  IS_ADVICE_ENABLED = 'v2-isAdviceEnabled',
  LAST_MAP = 'v2-keepTrack-earthTexture',
  COLOR_SCHEME = 'v2-keepTrack-colorScheme',
  SETTINGS_DRAW_CAMERA_WIDGET = 'v2-keepTrack-settings-drawCameraWidget',
  SETTINGS_DRAW_ORBITS = 'v2-keepTrack-settings-drawOrbits',
  SETTINGS_DRAW_ECF = 'v2-keepTrack-settings-drawECF',
  SETTINGS_DRAW_IN_COVERAGE_LINES = 'v2-keepTrack-settings-drawInCoverageLines',
  SETTINGS_DRAW_BLACK_EARTH = 'v2-keepTrack-settings-drawBlackEarth',
  SETTINGS_DRAW_ATMOSPHERE = 'v2-keepTrack-settings-drawAtmosphere',
  SETTINGS_DRAW_MILKY_WAY = 'v2-keepTrack-settings-drawMilkyWay',
  SETTINGS_DRAW_ASTEROID_BELT = 'v2-keepTrack-settings-drawAsteroidBelt',
  SETTINGS_GRAY_SKYBOX = 'v2-keepTrack-settings-graySkybox',
  SETTINGS_ECI_ON_HOVER = 'v2-keepTrack-settings-eciOnHover',
  SETTINGS_HOS = 'v2-keepTrack-settings-hos',
  SETTINGS_DEMO_MODE = 'v2-keepTrack-settings-demoMode',
  SETTINGS_SAT_LABEL_MODE = 'v2-keepTrack-settings-satLabelMode',
  SETTINGS_SAT_LABEL_MODE_V2 = 'v2-keepTrack-settings-satLabelModeV2',
  SETTINGS_FREEZE_PROP_RATE_ON_DRAG = 'v2-keepTrack-settings-freezePropRateOnDrag',
  SETTINGS_DISABLE_TIME_MACHINE_TOASTS = 'v2-keepTrack-settings-disableTimeMachineToasts',
  SETTINGS_FOCUS_ON_SAT_WHEN_SELECTED = 'v2-keepTrack-settings-focusOnSatWhenSelected',
  SETTINGS_SEARCH_LIMIT = 'v2-keepTrack-settings-searchLimit',
  SETTINGS_SHOW_DECAYED_IN_SEARCH = 'v2-keepTrack-settings-showDecayedInSearch',
  SETTINGS_MINIMUM_SEARCH_CHARACTERS = 'v2-keepTrack-settings-minimumSearchCharacters',
  SETTINGS_SHOW_VIMPEL_IN_SEARCH = 'v2-keepTrack-settings-showVimpelInSearch',
  SETTINGS_SEARCHABLE_FIELDS = 'v2-keepTrack-settings-searchableFields',
  SETTINGS_SEARCHABLE_TYPES = 'v2-keepTrack-settings-searchableTypes',
  SETTINGS_DRAW_TRAILING_ORBITS = 'v2-keepTrack-settings-drawTrailingOrbits',
  SETTINGS_DRAW_AURORA = 'v2-keepTrack-settings-drawAurora',
  SETTINGS_DRAW_GRATICULE = 'v2-keepTrack-settings-drawGraticule',
  SETTINGS_DRAW_FLAT_MAP_TERMINATOR = 'v2-keepTrack-settings-drawFlatMapTerminator',
  SETTINGS_DRAW_SUN = 'v2-keepTrack-settings-drawSun',
  SETTINGS_CONFIDENCE_LEVELS = 'v2-keepTrack-settings-confidenceLevels',
  SETTINGS_DRAW_COVARIANCE_ELLIPSOID = 'v2-keepTrack-settings-drawCovarianceEllipsoid',
  SETTINGS_COVARIANCE_CONFIDENCE_LEVEL = 'v2-keepTrack-settings-covarianceConfidenceLevel',
  GRAPHICS_SETTINGS_GODRAYS_SAMPLES = 'v2-keepTrack-graphicsSettings-godraysSamples',
  GRAPHICS_SETTINGS_GODRAYS_DECAY = 'v2-keepTrack-graphicsSettings-godraysDecay',
  GRAPHICS_SETTINGS_GODRAYS_EXPOSURE = 'v2-keepTrack-graphicsSettings-godraysExposure',
  GRAPHICS_SETTINGS_GODRAYS_DENSITY = 'v2-keepTrack-graphicsSettings-godraysDensity',
  GRAPHICS_SETTINGS_GODRAYS_WEIGHT = 'v2-keepTrack-graphicsSettings-godraysWeight',
  GRAPHICS_SETTINGS_GODRAYS_ILLUMINATION_DECAY = 'v2-keepTrack-graphicsSettings-godraysIlluminationDecay',
  GRAPHICS_SETTINGS_EARTH_DAY_RESOLUTION = 'v2-keepTrack-graphicsSettings-earthDayResolution',
  GRAPHICS_SETTINGS_EARTH_NIGHT_RESOLUTION = 'v2-keepTrack-graphicsSettings-earthNightResolution',
  FILTER_SETTINGS_OPERATIONAL_PAYLOADS = 'v2-filter-settings-operational-payloads',
  FILTER_SETTINGS_NON_OPERATIONAL_PAYLOADS = 'v2-filter-settings-non-operational-payloads',
  FILTER_SETTINGS_ROCKET_BODIES = 'v2-filter-settings-rocket-bodies',
  FILTER_SETTINGS_DEBRIS = 'v2-filter-settings-debris',
  FILTER_SETTINGS_UNKNOWN_TYPE = 'v2-filter-settings-unknown-type',
  FILTER_SETTINGS_VLEO = 'v2-filter-settings-vleo',
  FILTER_SETTINGS_LEO = 'v2-filter-settings-leo',
  FILTER_SETTINGS_HEO = 'v2-filter-settings-heo',
  FILTER_SETTINGS_MEO = 'v2-filter-settings-meo',
  FILTER_SETTINGS_GEO = 'v2-filter-settings-geo',
  FILTER_SETTINGS_X_GEO = 'v2-filter-settings-x-geo',
  FILTER_SETTINGS_VIMPEL = 'v2-filter-settings-vimpel',
  FILTER_SETTINGS_CELESTRAK = 'v2-filter-settings-celestrak',
  FILTER_SETTINGS_CELESTRAK_SUP = 'v2-filter-settings-celestrak-sup',
  FILTER_SETTINGS_SATNOGS = 'v2-filter-settings-satnogs',
  FILTER_SETTINGS_NOTIONAL = 'v2-filter-settings-notional',
  FILTER_SETTINGS_UNITED_STATES = 'v2-filter-settings-united-states',
  FILTER_SETTINGS_UNITED_KINGDOM = 'v2-filter-settings-united-kingdom',
  FILTER_SETTINGS_FRANCE = 'v2-filter-settings-france',
  FILTER_SETTINGS_GERMANY = 'v2-filter-settings-germany',
  FILTER_SETTINGS_JAPAN = 'v2-filter-settings-japan',
  FILTER_SETTINGS_CHINA = 'v2-filter-settings-china',
  FILTER_SETTINGS_INDIA = 'v2-filter-settings-india',
  FILTER_SETTINGS_RUSSIA = 'v2-filter-settings-russia',
  FILTER_SETTINGS_USSR = 'v2-filter-settings-ussr',
  FILTER_SETTINGS_SOUTH_KOREA = 'v2-filter-settings-south-korea',
  FILTER_SETTINGS_AUSTRALIA = 'v2-filter-settings-australia',
  FILTER_SETTINGS_OTHER_COUNTRIES = 'v2-filter-settings-other-countries',
  FILTER_SETTINGS_STARLINK = 'v2-filter-settings-starlink',
  FILTER_SETTINGS_GROUND_SENSORS = 'v2-filter-settings-ground-sensors',
  FILTER_SETTINGS_LAUNCH_FACILITIES = 'v2-filter-settings-launch-facilities',
  SENSOR_TIMELINE_ENABLED_SENSORS = 'v2-sensor-timeline-enabled-sensors',

  // Symbology
  SYMBOLOGY_CONFIG = 'v2-symbology-config',
  SYMBOLOGY_ENABLED = 'v2-symbology-enabled',

  // Command Palette
  COMMAND_PALETTE_RECENT = 'v2-command-palette-recent',

  // Neighborhood Watch
  NEIGHBORHOOD_WATCH_LIST = 'v2-keepTrack-neighborhoodWatchList',

  // Find Satellite Pro
  FIND_SAT_PRO_SAVED_SEARCHES = 'v2-find-sat-pro-saved-searches',

  // DOP Terrain Masks
  DOPS_TERRAIN_STORE = 'v2-keepTrack-dopsTerrainStore',

  // Favorites Menu
  FAVORITES_LIST = 'v2-keepTrack-favoritesList',

  // Observation Reader
  OBSERVATION_STATIONS = 'v2-keepTrack-observationStations',

  // Sat Constellations
  LAST_CONSTELLATION = 'v2-keepTrack-lastConstellation',

  // Plugin Drawer
  DRAWER_GROUP_STATES = 'v2-keepTrack-drawerGroupStates',
  DRAWER_RECENT_PLUGINS = 'v2-keepTrack-drawerRecentPlugins',
  DRAWER_RAIL_MODE = 'v2-keepTrack-drawerRailMode',

  VERSION = 'v2-version',

  // Doppler
  DOPPLER_REF_FREQUENCY = 'v2-keepTrack-dopplerRefFrequency',

  // Color Scheme Editor
  COLOR_SCHEME_OVERRIDES = 'v2-keepTrack-colorSchemeOverrides',

  // Achievement progress counters (mirrors the server-synced app_preferences copy)
  ACHIEVEMENT_COUNTERS = 'v2-keepTrack-achievementCounters',

  // Best Pass Pro (column visibility + propagation settings)
  BEST_PASS_SETTINGS = 'v2-keepTrack-bestPassSettings',

  // Sponsor ad dismissal (timestamp in ms until which the ad stays hidden)
  SPONSOR_AD_DISMISSED_UNTIL = 'v2-keepTrack-sponsorAdDismissedUntil',

  // Bottom banner ad dismissal (timestamp in ms until which the banner stays hidden)
  BOTTOM_BANNER_AD_DISMISSED_UNTIL = 'v2-keepTrack-bottomBannerAdDismissedUntil',

  // Stereo Map (map style, graticule, political overlay, orbit multiplier)
  STEREO_MAP_SETTINGS = 'v2-keepTrack-stereoMapSettings',

  // Aurora Pro (opt-in NOAA OVATION auto-refresh toggle)
  AURORA_AUTO_REFRESH = 'v2-keepTrack-auroraAutoRefresh',

  // Aurora Pro (opt-in: enable the high-accuracy overlay automatically on fetch)
  AURORA_AUTO_HIGH_ACCURACY = 'v2-keepTrack-auroraAutoHighAccuracy',

  // Scenario Management Pro (saved scenario library: name -> { savedAt, data })
  SCENARIO_LIBRARY = 'v2-keepTrack-scenarioLibrary',

  // Stars Pro (vmag limit, constellation label toggle)
  STARS_SETTINGS = 'v2-keepTrack-starsSettings',

  // Seismic Activity Pro (feed selection, min magnitude, auto-refresh)
  SEISMIC_ACTIVITY_SETTINGS = 'v2-keepTrack-seismicActivitySettings',

  // User Account (epoch ms of the last successful cloud sync)
  USER_LAST_SYNCED = 'v2-keepTrack-userLastSynced',

  // Proximity Ops (last-used search inputs: thresholds, orbit type, toggles)
  PROXIMITY_OPS_SETTINGS = 'v2-keepTrack-proximityOpsSettings',

  // Breakup (last-used variation inputs: inc/period/RAAN/ecc spread, count, start number)
  BREAKUP_SETTINGS = 'v2-keepTrack-breakupSettings',

  // Reports (last-used output options: time window, sampling step, export format)
  REPORTS_SETTINGS = 'v2-keepTrack-reportsSettings',

  // Calculator (last-used input frame, output format, and field values)
  CALCULATOR_SETTINGS = 'v2-keepTrack-calculatorSettings',

  // Multi-View Pro (split fraction + last-used secondary pane mode)
  MULTI_VIEW_SETTINGS = 'v2-keepTrack-multiViewSettings',

  // Onboarding (tour/checklist progress; survives version wipes via the
  // preservation allowlist in PersistenceManager.validateStorage)
  ONBOARDING_STATE = 'v2-keepTrack-onboardingState',

  // Access Timeline Pro (sensor objNames shown in the docked timeline strip)
  ACCESS_TIMELINE_ENABLED_SENSORS = 'v2-keepTrack-accessTimelineEnabledSensors',

  // Plugin Manager (per-plugin enable/disable overrides, diffed from manifest
  // defaults; survives version wipes via the preservation allowlist)
  PLUGIN_ENABLE_OVERRIDES = 'v2-keepTrack-pluginEnableOverrides',

  // Per-key sync timestamps for account-scoped keys: JSON Record<StorageKey, epochMs>.
  // Maintained by PersistenceManager; wiped on version bumps so a post-wipe login
  // lets the cloud copy win. Never syncs itself.
  SYNC_META = 'v2-keepTrack-syncMeta',
}
